<template>
<div>
  <v-flex v-if="this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm">
  <v-btn flat color="#009B99" style="text-decoration:none"
    v-if="exibetoolbarcell"
    @click.stop="drawer = !drawer"          
    icon
    dark
  >
    <v-icon>menu</v-icon>
  </v-btn>

  <v-navigation-drawer      
    v-model="drawer"
    absolute
    temporary
    left
    app
    fixed
    transition="fade-transition"
    dark    
  >
    <v-list class="pa-4">
      <v-list-tile tag="div">               
        <img src="../assets/logo.png" alt="Primavida Dental" width="130">                    
      </v-list-tile>
    </v-list>

    <v-list class="pt-0" dense>
      <v-divider dark></v-divider>

      <!-- Comercial -->
      <v-list-tile to="/" active-class="cyan darken-3" avatar>
        <v-list-tile-action>
          <v-icon>domain</v-icon>
        </v-list-tile-action>
        <v-list-tile-title>Comercial</v-list-tile-title>
      </v-list-tile>
      <!-- Home -->
      <v-list-tile href="https://www.primavida.com.br" active-class="cyan darken-3" avatar>
        <v-list-tile-action>
          <v-icon>home</v-icon>
        </v-list-tile-action>
        <v-list-tile-title>Home</v-list-tile-title>
      </v-list-tile>
      <!-- Rede Credenciada -->
      <v-list-tile href="https://www.primavida.com.br/redecredenciada" active-class="cyan darken-3" avatar>
        <v-list-tile-action>
          <v-icon>place</v-icon>
        </v-list-tile-action>
        <v-list-tile-title>Rede Credenciada</v-list-tile-title>
      </v-list-tile>
      <!-- Servidor Público -->
      <v-list-tile to="/servidor-publico" active-class="cyan darken-3" avatar>
        <v-list-tile-action>
          <v-icon>account_balance</v-icon>
        </v-list-tile-action>
        <v-list-tile-title>Servidor Público</v-list-tile-title>
      </v-list-tile>

      <!-- Pessoa Física -->
      <v-list-tile to="/pessoa-fisica" active-class="cyan darken-3" avatar>
        <v-list-tile-action>
          <v-icon>person</v-icon>
        </v-list-tile-action>
        <v-list-tile-title>Pessoa Física</v-list-tile-title>
      </v-list-tile>

      <!-- Pessoa Jurídica -->
      <v-list-tile to="/pessoa-juridica" active-class="cyan darken-3" avatar>
        <v-list-tile-action>
          <v-icon>domain</v-icon>
        </v-list-tile-action>          
        <v-list-tile-title>Pessoa Jurídica</v-list-tile-title>          
      </v-list-tile>

      <!-- Contato 
      <v-list-tile to="/contato" active-class="cyan darken-3" avatar>
        <v-list-tile-action>
          <v-icon>email</v-icon>
        </v-list-tile-action>          
        <v-list-tile-title>Contato</v-list-tile-title>          
      </v-list-tile> -->

      <!-- Área do Cliente -->
      <v-list-tile to="/areacliente" active-class="cyan darken-3" avatar>
        <v-list-tile-action>
          <v-icon>account_box</v-icon>
        </v-list-tile-action>          
        <v-list-tile-title>Área do Cliente</v-list-tile-title>          
      </v-list-tile>

      <!-- FAQ 
      <v-list-tile to="/faq" active-class="cyan darken-3" avatar>
        <v-list-tile-action>
          <v-icon>textsms</v-icon>
        </v-list-tile-action>          
        <v-list-tile-title>FAQ</v-list-tile-title>          
      </v-list-tile> -->

      <!-- Área de Acesso -->
      <v-list-group v-model="group" no-action>
        <template v-slot:activator>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon>lock</v-icon>
            </v-list-tile-action>
            <v-list-tile-title>Área de Acesso</v-list-tile-title>
          </v-list-tile>
        </template>

        <v-list-tile href="https://primavida.s4e.com.br/SYS/?TipoUsuario=100" target="_blank">
          <v-list-tile-title>Colaborador C</v-list-tile-title>
        </v-list-tile>
        <v-list-tile href="https://primavida.s4e.com.br/SYS/" target="_blank">
          <v-list-tile-title>Administrativo</v-list-tile-title>
        </v-list-tile>
        <v-list-tile href="https://primavida.s4e.com.br/SYS/?TipoUsuario=1" target="_blank">
          <v-list-tile-title>Beneficiário</v-list-tile-title>
        </v-list-tile>
        <v-list-tile href="https://primavida.s4e.com.br/SYS/?TipoUsuario=2" target="_blank">
          <v-list-tile-title>Empresa</v-list-tile-title>
        </v-list-tile>
        <v-list-tile href="https://primavida.s4e.com.br/SYS/?TipoUsuario=10" target="_blank">
          <v-list-tile-title>Corretor</v-list-tile-title>
        </v-list-tile>
        <v-list-tile href="https://primavida.s4e.com.br/SYS/?TipoUsuario=3-4" target="_blank">
          <v-list-tile-title>Dentista</v-list-tile-title>
        </v-list-tile>
        <v-list-tile href="https://webmail.primavida.com.br" target="_blank">
          <v-list-tile-title>Webmail</v-list-tile-title>
        </v-list-tile>
      </v-list-group>
    </v-list>
  </v-navigation-drawer>
</v-flex>
<v-flex  v-else>
<header class="main-header page-intern" v-if="exibetoolbar">
    <div class="center">
    <router-link to="/" class="main-logo">
        <img src="../assets/logo.png" alt="Primavida Dental">
    </router-link>
    <i class="fas fa-bars open-menu"></i>
    <div class="mask-menu-mobile"></div>
    <br>
    <br>
    <ul class="main-nav">
        <li>
            <router-link to="/" >Comercial</router-link>
        </li>
        <li>
          <a href="https://www2.primavida.com.br">Home</a>
        </li>
        <li>
          <a href="https://www.primavida.com.br/redecredenciada">Rede Credenciada</a>
        </li>
        <li>
            Planos Odontológicos <i class="fas fa-angle-down"></i>
            <div class="submenu">
                <router-link to="/pessoa-fisica">Pessoa Física</router-link>
                <!-- <a @click.prevent="exibeMsgConstrucao()" >Servidor Público</a> --> 
                <!-- <a @click="exibeMsgConstrucao()">Pessoa Jurídica</a> --> 
                <router-link to="/servidor-publico">Servidor Público</router-link>
                <router-link to="/pessoa-juridica">Pessoa Jurídica</router-link>
                
            </div>
        </li>
        <li>
            <router-link :to="{ path: '/contato' }">Contato</router-link>
        </li>
        <li>
            <router-link to="/areacliente" >Área do Cliente</router-link>
        </li>
        <li>
            <router-link to="/faq" >FAQ</router-link>
        </li>
        <li>
          Área de Acesso <i class="fas fa-angle-down"></i>
          <div class="submenu">
            <a href="https://primavida.s4e.com.br/SYS/?TipoUsuario=100">Colaborador C.</a>
            <a href="https://primavida.s4e.com.br/SYS/" >Administrativo</a>
            <a href="https://primavida.s4e.com.br/SYS/?TipoUsuario=1" >Beneficiário</a>
            <a href="https://primavida.s4e.com.br/SYS/?TipoUsuario=2" >Empresa</a>
            <a href="https://primavida.s4e.com.br/SYS/?TipoUsuario=10">Corretor</a>
            <a href="https://primavida.s4e.com.br/SYS/?TipoUsuario=3-4">Dentista</a>
            <a href="https://webmail.primavida.com.br/">Webmail</a>
          </div>
        </li>
        <li v-if="userloggedin">
            <a @click="Sair" >Sair</a>
        </li>
    </ul>
</div>
</header>  
</v-flex>
<Snackbar ref=chamaSnackbar /> 
</div> 
</template>

<script>
import Snackbar from '../components/snackbar.vue'
import { mapState } from 'vuex'
export default {
     components: {Snackbar},
  data(){
        return{
            drawer: null,
            clipped: true,
            mini: false

        }
    },
    computed: {
       ...mapState({
        userloggedin: state => state.userloggedin,
        exibetoolbar: state => state.isToolbarVisible,
        exibetoolbarcell: state => state.isToolbarVisibleCell
    }),
    imageHeight() {
    switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '220px'
        case 'sm': return '400px'
        case 'md': return '500px'
        case 'lg': return '600px'
        case 'xl': return '800px'
      }
      return true
    }
    },
    mounted : function(){
      this.$store.dispatch('ExibeToolbar')
    },
    methods: {
    Sair(){
            this.$store.dispatch('Sair')
            this.$router.push({ path: '/areacliente' })
        },
    exibeMsgConstrucao(){
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#0288D1","Disponível em breve!","INFORMAÇÃO")
        }
    }
}
</script>

<style>
    .buttom{
        text-transform: none;
        font-size: 1.1rem;
        font-weight: 390;
    }
    .v-btn:before {
        opacity: 0;
    }
</style>
